import * as React from 'react';

// PACKAGES
import Moment from 'react-moment';

// TYPES
interface DisplayDateTimeTypes {
	children?: string | number | Date | moment.Moment;
}

export const DisplayDateTime: React.FC<DisplayDateTimeTypes> = ({ children }) => {
	return (
		<Moment format="DD/MM/YYYY hh:mm A" parse="YYYY-MM-DDTHH:mm:ss.SSSSSSSZ">
			{children}
		</Moment>
	);
};

export default DisplayDateTime;
